import { render, staticRenderFns } from "./VmModal.vue?vue&type=template&id=7a8f965d&"
import script from "./VmModal.vue?vue&type=script&lang=js&"
export * from "./VmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports